import { format } from 'date-fns';
const DATE_FORMAT = 'yyyy-MM-dd HH:mm';

export default class ImmersiveReaderContentBuilder {
  constructor(title) {
    this.content = {
      title: (title || '').trim(),
      chunks: [],
    };
  }

  addChunk(content, mimeType = undefined) {
    this.content.chunks.push({
      content,
      mimeType,
    });
  }

  addHtmlChunk(content, prefix = null, elementType = 'div') {
    const dom = $(`<${elementType}>${prefix ? prefix + ':' : ''}${content}</${elementType}>`);

    // handle custom embedded links
    [...dom.find('.embed-template')].forEach((element) => {
      const [title, description] = $(element)
        .find('.title-preview, .description-preview')
        .map((index, field) => field.innerHTML);
      $(element).replaceWith(`<p>${title}</p><p>${description}</p>`);
    });

    // remove elements flagged for hiding
    dom.find('.ir-hide').remove();

    // remove empty paragraphs
    const processedContent = dom[0].outerHTML.replaceAll('<p><br></p>', '');
    this.addChunk(processedContent, 'text/html');
  }

  getContent() {
    if (this.content.chunks.length === 0) {
      this.addHtmlChunk('<p><br/></p>');
    }
    return this.content;
  }

  getReportData(content) {
    if (content?.report?.state !== 'blank' && content?.participations?.length) {
      const report = content.report;
      const names = content?.participations.map((user) => user.full_name).join(', ');
      const date = format(new Date(report.updated_at), DATE_FORMAT);
      if (report.name) {
        this.addChunk(`${report.name}: ${names}, ${date}.`);
      } else {
        this.addChunk(`${names}, ${date}.`);
      }
      this.addHtmlChunk(report.body);
    }
  }

  buildLoop() {
    const html = $('.panelContent').html();
    this.addHtmlChunk(html);
  }

  buildNode(content) {
    this.content.title = content.name;
    const html = $('.panelContent').html();
    this.addHtmlChunk(html);
  }

  buildBlog(content) {
    const addReport = (report) =>
      (report.BlogPosts || []).forEach((blogPost) => {
        const name = report?.Participation?.OrganisationParticipation?.User?.full_name || '';
        const date = format(new Date(blogPost.updated_at), DATE_FORMAT);
        this.addChunk(`${name}, ${date}.`);
        this.addHtmlChunk(blogPost.content);
      });
    if (content.reports) {
      content.reports.forEach((report) => addReport(report));
    } else if (content.report) {
      addReport(content.report);
    }
  }

  buildCorrelation(content) {
    const correlationDescriptions = [];
    const concepts = content.CorrelationList.Concepts;
    for (let concept of concepts || []) {
      correlationDescriptions.push(concept.Description);
    }
    (content.CorrelationList.Concepts || []).forEach((concept) => {
      this.addHtmlChunk(`${concept.body}`);
      const answer = (content?.report?.CorrelationAnswers || []).find(
        (answer) => answer.correlation_concept_id === concept.id,
      );
      if (answer) {
        const conceptDescription = correlationDescriptions.find(
          (description) => description.id === answer.correlation_description_id,
        );
        if (conceptDescription) {
          this.addHtmlChunk(`${conceptDescription.body}`);
        }
      }
    });
  }

  buildEvaluation(content) {
    this.addHtmlChunk(content.placeholder);
    this.getReportData(content);
  }

  buildLegend(content) {
    const concepts = content.CorrelationList.CorrelationConcepts || content.CorrelationList.Concepts;
    (concepts || []).forEach((concept) => {
      this.addHtmlChunk(concept.body, i18n.__('correlation_term'));
      this.addHtmlChunk(
        concept?.CorrelationDescription?.body || concept?.Description?.body,
        i18n.__('correlation_description'),
      );
    });
  }

  buildTask(content) {
    this.getReportData(content);
  }

  buildQuiz(content) {
    if (content.role === 'teacher') {
      const name = content.user?.full_name;
      if (name) {
        this.addChunk(name);
      }
    }

    const questions = content.QuizQuestions;
    (questions || []).forEach((question, index) => {
      this.addHtmlChunk(question.body, i18n.__('quiz_question_number', { number: index + 1 }));

      const alternatives = question.QuizAlternatives;
      const sortedAlternatives = (alternatives || []).sort((a, b) => {
        return a.order - b.order;
      });

      if (content.role === 'teacher') {
        if (content.answers && Object.keys(content.answers).length > 0) {
          sortedAlternatives.forEach((alternative, alternativeIndex) => {
            if (alternative.id === content.answers[question.id]) {
              this.addHtmlChunk(alternative.body, i18n.__('quiz_alternative_number', { number: alternativeIndex + 1 }));
            }
          });
        }
      } else {
        sortedAlternatives.forEach((alternative, alternativeIndex) => {
          this.addHtmlChunk(alternative.body, i18n.__('quiz_alternative_number', { number: alternativeIndex + 1 }));
        });
      }
    });
  }

  buildChecklist(content) {
    this.addHtmlChunk(
      (content.ChecklistItems || [])
        .sort((a, b) => a.order - b.order)
        .map((checklistItem) => `<li>${checklistItem.content}</li>`)
        .join(''),
      null,
      'ul',
    );
  }

  buildFromContent(content = {}, entityType = null) {
    this.content.chunks = [];
    const data = { ...content, ...content.data };

    if (!this.content.title) {
      this.content.title = data.name || data?.Behavior?.Node?.name?.trim();
    }

    if (data.body || data.content) {
      this.addHtmlChunk(data.body || data.content);
    }

    const buildMap = {
      loop: this.buildLoop,
      node: this.buildNode,
      blog: this.buildBlog,
      correlation: this.buildCorrelation,
      evaluation: this.buildEvaluation,
      legend: this.buildLegend,
      task: this.buildTask,
      quiz: this.buildQuiz,
      checklist: this.buildChecklist,
    };

    if (entityType && buildMap[entityType]) {
      buildMap[entityType].bind(this)(data);
    }
  }
}
